export const PRODUCTS = [
    { key: 'nolteKuechen', label: 'Nolte Küchen' },
    { key: 'nolteEco', label: 'Nolte Eco' },
    { key: 'expressKuechen', label: 'Express Küchen' },
    { key: 'nolteSPA', label: 'Nolte SPA' },
    { key: 'nolteNeo', label: 'Nolte Neo' },
];

export const MAIN_REPORT_COLUMNS = [
    { key: 'customer', label: 'CUSTOMER', align: 'left' },
    ...PRODUCTS,
    { key: 'total', label: 'Total', align: 'right' },
    { key: 'internalBudget', label: 'Internal Budget', align: 'right' },
    { key: 'percentageAchieved', label: 'Percentage Achieved', align: 'right' },
    { key: 'achievedProRata', label: 'Achieved- Pro Rata Basis', align: 'right' },
];

export const SUMMARY_COLUMNS = [
    { key: 'category', label: 'CATEGORY', align: 'left' },
    ...PRODUCTS,
    { key: 'total', label: 'Total', align: 'right' },
    { key: 'internalBudget', label: 'Internal Budget', align: 'right' },
    { key: 'percentageAchieved', label: 'Percentage Achieved', align: 'right' },
    { key: 'achievedProRata', label: 'Achieved- Pro Rata Basis', align: 'right' },
];

export const TERRITORY_SUMMARY_COLUMNS = [
    { key: 'territory', label: 'TERRITORY/CATEGORY', align: 'left' },
    ...PRODUCTS,
    { key: 'total', label: 'Total', align: 'right' },
    { key: 'internalBudget', label: 'Internal Budget', align: 'right' },
    { key: 'percentageAchieved', label: 'Percentage Achieved', align: 'right' },
    { key: 'achievedProRata', label: 'Achieved- Pro Rata Basis', align: 'right' },
];